import React, { useState } from "react";
import { Calendar, HelpCircle } from "react-feather";
import { Link } from "react-router-dom";
import { Input, Label, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { useAuth } from "../../../Auth/AuthContext";
import { getApiError } from "../../../api/client";

const WorkspaceControls = () => {
  const [dateOpen, setDateOpen] = useState(false);
  const { user, companySwitching, dateRange, setDateRange, switchCompany } = useAuth();
  const onCompanyChange = async (event) => {
    try { await switchCompany(event.target.value); }
    catch (error) { toast.error(getApiError(error, "Unable to switch company.")); }
  };

  return <>
    <li className="workspace-company-control px-2">
      <Label className="visually-hidden" for="global-company">Company</Label>
      <div className="d-flex align-items-center gap-2">
        {companySwitching && <Spinner size="sm" aria-label="Switching company" />}
        <Input id="global-company" type="select" bsSize="sm" value={user?.company?.id || ""} onChange={onCompanyChange} disabled={companySwitching} aria-label="Selected company">
          {(user?.companies || []).map((company) => <option key={company.id} value={company.id}>{company.name}</option>)}
        </Input>
      </div>
    </li>
    <li className="workspace-date-control onhover-dropdown px-2">
      <button type="button" className="border-0 bg-transparent d-flex align-items-center gap-2" aria-label={`Date range ${dateRange.start} to ${dateRange.end}`} aria-expanded={dateOpen} onClick={() => setDateOpen(!dateOpen)}>
        <Calendar aria-hidden="true" /><span className="d-none d-xxl-inline">{dateRange.start} – {dateRange.end}</span>
      </button>
      <div className={`notification-dropdown onhover-show-div p-3 ${dateOpen ? "active" : ""}`}>
        <Label for="global-date-start">Start date</Label>
        <Input id="global-date-start" type="date" bsSize="sm" value={dateRange.start} max={dateRange.end} onChange={(event) => setDateRange({ ...dateRange, start: event.target.value })} />
        <Label className="mt-2" for="global-date-end">End date</Label>
        <Input id="global-date-end" type="date" bsSize="sm" value={dateRange.end} min={dateRange.start} onChange={(event) => setDateRange({ ...dateRange, end: event.target.value })} />
      </div>
    </li>
    <li title="Help"><Link to="/guidance" className="d-flex align-items-center" aria-label="Help and guidance"><HelpCircle aria-hidden="true" /></Link></li>
  </>;
};

export default WorkspaceControls;
